"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCandid = void 0;
const userId_1 = require("./userId");
const option_1 = require("./option");
function fromCandid(myProfile) {
    return {
        userId: userId_1.fromCandid(myProfile.id),
        username: myProfile.username,
        accountBalance: BigInt(myProfile.account_balance),
        imageId: option_1.fromCandid(myProfile.image_id),
        imageBlobUrl: null,
        version: myProfile.version
    };
}
exports.fromCandid = fromCandid;
